import {apolloClient} from '@/setup/apollo-setup';
import {getField, updateField} from 'vuex-map-fields';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';

import {
  ADD_SUBJECT,
  DELETE_SUBJECT,
  GET_SUBJECTS,
  GET_SUBJECTS_DDL,
  GET_SUBJECT_BY_SUBJECTGROUP_ID,
  GET_SUBJECT,
  UPDATE_SUBJECT,
} from '@/queries/modules/common-data/subject';

//
// initial state
const state = {
  subject: {
    id: '',
    degreeId: null,
    subjectGroupId: null,
    code: '',
    nameLocal: '',
    nameEng: '',
    description: '',
    creditCalGrade: null,
    creditDesc: '',
  },
  subjects: [],
  subjectsDdl: [],
  processing: false,
  error: null,
  success: null,
};

//
// getters
const getters = {
  getField
};

//
// mutations
const mutations = {
  updateField,
  clearError: (state) => {
    state.error = null;
  },
  setError: (state, payload) => {
    state.error = payload;
    state.success = null;
    state.processing = false;
  },
  setSuccess: (state, payload) => {
    state.error = null;
    state.success = payload;
    state.processing = false;
  },
  setProcessing: (state, payload) => {
    state.processing = payload;
  },
  setSubjects: (state, payload) => {
    state.subjects = payload ? payload : [];
  },
  setSubjectsDdl: (state, payload) => {
    state.subjectsDdl = payload ? payload : [];
  },
  setSubject: (state, payload) => {
    state.subject = payload;
  },
  setSelectedSubject: (state, payload) => {
    state.subject = {...payload};
  },
  clearSelectedSubject: (state) => {
    state.subject = {
      id: '',
      degreeId: null,
      subjectGroupId: null,
      code: '',
      nameLocal: '',
      nameEng: '',
      description: '',
      creditCalGrade: null,
      creditDesc: '',
    }
  }
};

//
// actions
const actions = {
  getSubjects: async ({commit}, useState = true) => {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_SUBJECTS,
          fetchPolicy: 'network-only',
          context: { clientName: 'Prisma2' }
        });

      const { data, errors } = await result;

      if (errors) {
        commit('setError', error(errors));
        return state.subjects;
      }else{
        if(useState){
          commit('setSubjects', data.getSubjects);
        }
        commit('setSuccess', null);
        return data.getSubjects
      }

    } catch (e) {
      commit('setError', error(e));
      return state.subjects;
    }

  },
  getSubjectsDdl: async ({commit}, useState = true) => {
    commit('setProcessing', true);
    try {
      const result = await apolloClient
        .query({
          query: GET_SUBJECTS_DDL,
          fetchPolicy: 'network-only',
          context: { clientName: 'Prisma2' }
        });

      const { data, errors } = await result;

      if (errors) {
        commit('setError', error(errors));
        return state.subjectsDdl;
      }else{
        if(useState){
          commit('setSubjectsDdl', data.getSubjects);
        }
        commit('setSuccess', null);
        return data.getSubjects
      }

    } catch (e) {
      commit('setError', error(e));
      return state.subjectsDdl;
    }

  },
  getSubject: async ({commit}, id) => {
    commit('setProcessing', true);

    apolloClient
      .query({
        query: GET_SUBJECT,
        variables: {
          id: id
        },
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        commit('setSubject', data.getSubject);
        commit('setSuccess', null);
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  getSubjectBySubjectGroupID: async ({ commit }, payload) => {
    let sideEffects;
    commit('setProcessing', true);

    try {
      const result = await apolloClient
        .query({
          query: GET_SUBJECT_BY_SUBJECTGROUP_ID,
          variables: payload,
          context: { clientName: 'Prisma2' }
        });
      const { data } = await result;

      // TODO: Handle after success;
      sideEffects = {
        status: { success: true, error: false, message: "" },
        data: [ ...data.getSubjectsBySubjectGroup ]
      };

      commit('setSubjects', data.getSubjectsBySubjectGroup);
      commit('setSuccess', null);
      return sideEffects;

    } catch (err) {
      commit('setError', error(err));
      return { status: { success: false, error: true, message: "", full: err }};
    }
  },
  addSubject: async ({commit}, payload) => {
    commit('setProcessing', true);
    await apolloClient
      .mutate({
        mutation: ADD_SUBJECT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        const subjects = [...state.subjects];
        subjects.push(data.addSubject);
        commit('setSubjects', subjects);
        commit('setSuccess', newItemSuccess(data.addSubject.nameLocal));
      })
      .catch((err) => {
        commit('setError', error(err));
      });
  },
  updateSubject: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: UPDATE_SUBJECT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        const index = state.subjects.findIndex(subject => subject.id === data.updateSubject.id);
        const subjects = [
          ...state.subjects.slice(0, index),
          data.updateSubject,
          ...state.subjects.slice(index + 1)
        ];

        commit('setSubjects', subjects);
        commit('setSuccess', updateItemSuccess(data.updateSubject.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  deleteSubject: async ({commit}, payload) => {
    commit('setProcessing', true);

    apolloClient
      .mutate({
        mutation: DELETE_SUBJECT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      })
      .then(({data}) => {
        const index = state.subjects.findIndex(subject => subject.id === data.deleteSubject.id);
        const subjects = [
          ...state.subjects.slice(0, index),
          ...state.subjects.slice(index + 1)
        ];

        commit('setSubjects', subjects);
        commit('setSuccess', deleteItemSuccess(data.deleteSubject.nameLocal));
      })
      .catch(({err}) => {
        commit('setError', error(err));
      });
  },
  selectedSubject: async ({commit}, payload) => {
    commit('setSelectedSubject', payload);
  },
  clearSelectedSubject: async ({commit}) => {
    commit('clearSelectedSubject');
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
